import { Language } from '@barracuda/shared';
import { AxiosResponse } from 'axios';
import { saveAs } from 'file-saver';

export function isMobile(): boolean {
  return (
    !!(
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) ||
    isAndroid() ||
    isIOS()
  );
}

export function isAndroid(): boolean {
  return !!navigator.userAgent.match(/Android/i);
}

export function isIOS(): boolean {
  return !!(
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i)
  );
}
// Removing support for different language
// export const SUPPORTED_LANGUAGES: Language[] = ['ENG', 'JPN', 'KOR'];
export const SUPPORTED_LANGUAGES: Language[] = ['ENG'];
export const VALID_LANGUAGE_PREFIXES: string[] = SUPPORTED_LANGUAGES.map((lang) => `/${lang}/`);
export const IGNORE_PATHS = [
  '/version.txt',
  '/assets/favicon.ico',
  '/assets/favicon_dark.ico',
  '/assets/favicon_logo.png'
];

export const saveAxiosResponseFile = (response: AxiosResponse<Blob, any>) => {
  const filename = response.headers['content-disposition'].split(';')[1] as string;
  const name = filename.split('"')[1] as string;
  saveAs(response.data, name);
};

export const isTouchDevice = () =>
  // @ts-ignore
  'ontouchstart' in window || navigator.maxTouchPoints > 0;

/**
 * Builds an absolute IDV service URL from the bare host in REACT_APP_IDV_SERVICE_URL.
 *
 * @param path - Absolute path including its leading slash, e.g. `/api/regula`.
 * @returns The full URL, or an empty string when the host is not configured.
 */
export const getIdvUrl = (path: string): string => {
  const host = process.env.REACT_APP_IDV_SERVICE_URL ?? '';

  return host ? `${host}${path}` : '';
};
